// useCreateSubQuery Hook
import { useState, useCallback, useMemo } from "react";
import { QueryEntity, CreateSubQueryParams } from "../../domain/entities/QueryEntity";
import { CreateSubQueryUseCase } from "../../domain/use-cases/CreateSubQueryUseCase";
import { QueriesRepositoryImpl } from "../../data/repositories/QueriesRepositoryImpl";
import { queriesApi } from "../../data/api/queriesApi";
import { Result } from "../../domain/common/Result";

export const useCreateSubQuery = () => {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Instantiate repository and use case
  const repository = useMemo(
    () => new QueriesRepositoryImpl(queriesApi),
    []
  );

  const createSubQueryUseCase = useMemo(
    () => new CreateSubQueryUseCase(repository),
    [repository]
  );

  const createSubQuery = useCallback(
    async (params: CreateSubQueryParams): Promise<Result<QueryEntity>> => {
      setCreating(true);
      setError(null);

      const result = await createSubQueryUseCase.execute(params);

      if (result.isFailure) {
        setError(result.error);
      }

      setCreating(false);
      return result;
    },
    [createSubQueryUseCase]
  );

  return {
    createSubQuery,
    creating,
    error,
  };
};

